module.exports = __webpack_public_path__ + "img/scrap.86f8984e.jpg";